export enum CashFlowTransactionType {
  RECEIPT = 'receipt',
  TRANSPORT = 'transport',
  RECHARGE = 'recharge',
  EVENT = 'event',
  TEST = 'test',
  HAPPY_HOUR = 'happy_hour',
  PARKING = 'parking',
  FIRST_CONTACT = 'first_contact',
  CRAFT = 'craft',
  SERVICE_PROVISION = 'service_provision',
  PURCHASE_RAW_MATERIAL = 'purchase_raw_material',
  OTHER = 'other',
  REWARD = 'reward',
  SALARY = 'salary',
  BANK_CHECK = 'bank_check',
  LOAN = 'loan',
  BANK_HOUR_PAYMENT = 'bank_hour_payment',
  CLEANING = 'cleaning',
}
